<template>
    <div class="kt-portlet__head">
        <form class="isprint-filter" autocomplete="off"> 
            <div class="form-group  ">
                <label>Titolo pratica</label><br>
                <input class="form-control form-control-sm"  autocomplete="off" name="adasd" placeholder="Titolo" type="text" style="width:200px" v-model="search.TITOLO.VALUE">
            </div>
            <div class="form-group  ">
                <label>Intestatario</label><br>
                <input class="form-control form-control-sm"  autocomplete="off" name="adasd" placeholder="Denominazione" type="text" style="width:200px" v-model="search.CONCAT_DENOMINAZIONE.VALUE">
            </div>
            <div class="form-group">
                <label>Stato</label>
                <select class="form-control form-control-sm" v-model="search.FK_ID_STATO.VALUE">
                    <option value="">Qualsiasi</option>
                    <option v-for="stato in this.arrayStati" v-bind:value="stato.ID_STATO" v-bind:key="stato.ID_STATO">
                    {{ stato.DESCRIZIONE}}
                    </option>
                </select>
            </div>
            <div class="form-group">
                <label>Tipologia</label>
                <select class="form-control form-control-sm" v-model="search.FK_ID_TIPO.VALUE">
                    <option value="">Qualsiasi</option>
                    <option v-for="tipologia in this.$root.arrayTipologiePratica" v-bind:value="tipologia.ID_TIPOLOGIA" v-bind:key="tipologia.ID_TIPOLOGIA">
                    {{ tipologia.DESCRIZIONE}}
                    </option>
                </select>
            </div>
            <div class="form-group">
                <label>Data da</label><br/>
                <DatePicker autocomplete="off" :dim="'sm'" type="text" style="width:110px" v-model="search.DATA_CREAZIONE.VALUE_FROM"></DatePicker>
            </div>
            <div class="form-group">
                <label>Data a</label><br/>
                <DatePicker autocomplete="off" :dim="'sm'" type="text" style="width:110px" v-model="search.DATA_CREAZIONE.VALUE_TO"></DatePicker>
            </div>
            <div class="form-group  ">
                <label>Note</label><br>
                <input class="form-control form-control-sm"  autocomplete="off" name="adasd" placeholder="Note" type="text" style="width:200px" v-model="search.NOTE.VALUE">
            </div>
            <button class="btn btn-success float-right my-2 my-sm-3 mt-4 btn-sm" v-on:click="creaPratica()"><i class="fas fa-plus"></i> Nuova Pratica</button>
        </form> 
    </div>
    <div class="isprint-grid-container"  >    
        <table class="isprint-grid shadow" >
            <thead class="isprint-grid-thead" >
                <tr style="left: 0px;background: #ffad69;color:#fff">
                    <th  style="width:30%"><span >Titolo</span></th>
                    <th  style="width:10%"><span >Stato</span></th>
                    <th  style="width:20%"><span >Tipologia</span></th>
                    <th  style="width:30%"><span >Intestatari</span></th>
                    <th  style="width:10%"><span >Azioni</span></th>
                </tr>
            </thead>
            <tbody class="isprint-grid-tbody" style="font-size:14px !important">
                <tr style="left: 0px;height:50px" v-bind:key="pratica.ID_PRATICA"  v-for="pratica in paginatedList.arr">                        
                    <td  style="width:30%;font-size:16px">
                        <div class="float-left ml-1">
                            <i class="fa-3x" v-bind:class="pratica.ICONA"  style="color:#ffad69"></i>
                        </div>
                        <div class="float-left ml-3">
                            <strong>[{{ pratica.ID_PRATICA }}] {{ pratica.TITOLO }}</strong>
                            <br/>
                            <small>DATA CREAZIONE: {{filters.formatDate(pratica.DATA_CREAZIONE)}}</small>                            
                        </div>
                    </td>
                    <td  style="width:10%">
                        <span v-show="pratica.FK_ID_STATO == 1" class="badge badge-warning" style="font-size:14px;width:130px;text-transform:uppercase">
                            {{ getLabelStato(pratica.FK_ID_STATO) }} 
                        </span>
                        <span v-show="pratica.FK_ID_STATO == 2" class="badge badge-info" style="font-size:14px;width:130px;text-transform:uppercase">
                            {{ getLabelStato(pratica.FK_ID_STATO) }} 
                        </span>
                        <span v-show="pratica.FK_ID_STATO == 3" class="badge badge-success" style="font-size:14px;width:130px;text-transform:uppercase">
                            {{ getLabelStato(pratica.FK_ID_STATO) }} 
                        </span>
                        <span v-show="pratica.FK_ID_STATO == 4" class="badge badge-danger" style="font-size:14px;width:130px;text-transform:uppercase">
                            {{ getLabelStato(pratica.FK_ID_STATO) }} 
                        </span>
                        <span v-show="pratica.FK_ID_STATO == 0" class="badge badge-dark " style="font-size:14px;width:130px;text-transform:uppercase">
                            {{ getLabelStato(pratica.FK_ID_STATO) }} 
                        </span>
                    </td>
                    <td  style="width:20%;font-size:16px;">
                        {{ getLabelTipologia(pratica.FK_ID_TIPO) }}
                    </td>
                    
                    <td  style="width:30%">
                        <div v-for="intestatario in pratica.INTESTATARI" v-bind:key="intestatario">
                            <span class="intestatario" v-on:click="openPraticheIntestatario(intestatario,intestatario.TIPO)"><i class="fal mr-1" v-bind:class="{'fa-user': intestatario.TIPO == 1, 'fa-university':intestatario.TIPO == 2 }"></i>{{ intestatario.DENOMINAZIONE }}</span>
                        </div>
                    </td>
                    <td  style="width:10%">
                        <div class="btn-group float-right" role="group" aria-label="Basic example">
                            <button data-toggle="tooltip" data-placement="top" title="Modifica il cliente" class="btn btn-warning btn-sm float-right" v-on:click="modificaPratica(pratica.ID_PRATICA)"><i class="fal fa-pencil"></i></button>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
        <Pagine v-model="search.PAGINATION.PAGE_NUMBER"  :numrighe="paginatedList.count"  :numpagine="search.PAGINATION.LENGTH"></Pagine> 
    </div>
    <SchedaPratica :ref="'schedaPratica'" @salvataggio="getPratiche()" @cambiaPratica="cambiaPratica" :praticaCorrente="praticaCorrente" :arrayStati="arrayStati"></SchedaPratica>
    <PraticheIntestatario :ref="'praticheIntestatario'" :arrayStati="arrayStati"></PraticheIntestatario>

</template>
<script>


import Pagine from '@/components/utils/Pagine.vue'
import SchedaPratica from '../components/SchedaPratica.vue'
import PraticheIntestatario from '../components/PraticheIntestatario.vue';
import DatePicker from '@/components/utils/DatePicker.vue'


export default {
    name:"Pratiche",
    components:{
        Pagine,
        SchedaPratica,
        PraticheIntestatario,
        DatePicker
    },
    data:function(){
        return{
            filters:global.filters,
            search:{
                PAGINATION:{LENGTH:0,PAGE_NUMBER:1,PAGE_SIZE:50},
                CONCAT_DENOMINAZIONE:{TYPE:'TEXT',VALUE:''}, 
                TITOLO:{TYPE:'TEXT',VALUE:''},   
                ID_PRATICA:{TYPE:'TEXT',VALUE:''}, 
                FK_ID_TIPO:{TYPE:'COMBO',VALUE:''}, 
                FK_ID_STATO:{TYPE:'COMBO',VALUE:''}, 
                DATA_CREAZIONE:{TYPE:'DATE_RANGE',VALUE_FROM:'',VALUE_TO:''},
                NOTE:{TYPE:'TEXT',VALUE:''},                   
            },        
            arrayPratiche:new Array(),
            arrayStati:{},
            praticaCorrente: 0
        
        }
    },
    methods: {
        getPratiche : function(){
            global.utils.get('/emmet/pratiche',{}, (response) => {       
                this.arrayPratiche = response.data           
            });
        },    
        creaPratica : function(){
            this.$refs.schedaPratica.openPratica(0);
        },
        modificaPratica : function(idPratica){
            this.$refs.schedaPratica.openPratica(idPratica);
        //    this.praticaCorrente = idPratica;
        },
        deletePratica : function(idPratica){
            utils.alert.confirm("Sei sicuro di voler eliminare questa pratica?",()=>{
            global.utils.delete('/emmet/pratica',{ID_PRATICA: idPratica},(response) => {
                if (response.esito == 0){
                    utils.alert.success(response.messaggio);
                    this.getPratiche();
                }

            });
        },this.$root);  
        },
        getLabelStato : function(idStato){
            var r =  utils.array.select(this.arrayStati,"ID_STATO",idStato,1)[0];
            return r != undefined ? r.DESCRIZIONE : "-";
        },
        getLabelTipologia : function(idTipologia){
            var r = utils.array.select(this.$root.arrayTipologiePratica,"ID_TIPOLOGIA",idTipologia,1)[0];
            return r != undefined ? r.DESCRIZIONE : "-";
        },
        openPraticheIntestatario : function(intestatario,tipo){
            var persona = tipo == 1 ? {ID_PERSONA_FISICA:intestatario.ID_PERSONA_FISICA} : {ID_PERSONA_GIURIDICA:intestatario.ID_PERSONA_GIURIDICA};
            this.$refs.praticheIntestatario.praticheIntestatario(persona,tipo);
        },
        cambiaPratica : function(nPratica){
            this.modificaPratica(nPratica);
        }
        
    },
    computed : {
        paginatedList(){
            var arr = utils.inGrid(this.arrayPratiche,this.search);
            return arr;
        }, 
    },
    created : function(){
        global.utils.get('/emmet/stati',{}, (response) => {       
            this.arrayStati = response.data
            this.getPratiche()       
        });
   
    },

}


</script>
